module.exports = __webpack_public_path__ + "static/media/icon-questions-icon.2f26e17a.svg";